import { Accordion } from "./accordion"
import { Airy } from "./airy"
import { Alert } from "./alert"
import { AlphaSlider } from "./alpha-slider"
import { AreaChart } from "./area-chart"
import { Autocomplete } from "./autocomplete"
import { Avatar } from "./avatar"
import { Badge } from "./badge"
import { BarChart } from "./bar-chart"
import { Blockquote } from "./blockquote"
import { Breadcrumb } from "./breadcrumb"
import { Button } from "./button"
import { Calendar } from "./calendar"
import { Card } from "./card"
import { Carousel } from "./carousel"
import { Checkbox } from "./checkbox"
import { CheckboxCard } from "./checkbox-card"
import { CircleProgress } from "./circle-progress"
import { CloseButton } from "./close-button"
import { Code } from "./code"
import { Collapse } from "./collapse"
import { ColorPicker } from "./color-picker"
import { ColorSelector } from "./color-selector"
import { ColorSwatch } from "./color-swatch"
import { Container } from "./container"
import { ContextMenu } from "./context-menu"
import { DataList } from "./data-list"
import { DatePicker } from "./date-picker"
import { Dialog } from "./dialog"
import { Divider } from "./divider"
import { DonutChart } from "./donut-chart"
import { Drawer } from "./drawer"
import { Dropzone } from "./dropzone"
import { Editable } from "./editable"
import { Em } from "./em"
import { EmptyState } from "./empty-state"
import { Fade } from "./fade"
import { Fieldset } from "./fieldset"
import { FileButton } from "./file-button"
import { FileInput } from "./file-input"
import { Flip } from "./flip"
import { For } from "./for"
import { FormControl } from "./form-control"
import { FormatByte } from "./format-byte"
import { FormatNumber } from "./format-number"
import { Heading } from "./heading"
import { HueSlider } from "./hue-slider"
import { Icon } from "./icon"
import { Image } from "./image"
import { Indicator } from "./indicator"
import { InfiniteScrollArea } from "./infinite-scroll-area"
import { Input } from "./input"
import { Kbd } from "./kbd"
import { LineChart } from "./line-chart"
import { Link } from "./link"
import { LinkBox } from "./link-box"
import { List } from "./list"
import { Loading } from "./loading"
import { Mark } from "./mark"
import { Markdown } from "./markdown"
import { Menu } from "./menu"
import { Modal } from "./modal"
import { MonthPicker } from "./month-picker"
import { MultiAutocomplete } from "./multi-autocomplete"
import { MultiDatePicker } from "./multi-date-picker"
import { MultiSelect } from "./multi-select"
import { NativeSelect } from "./native-select"
import { NativeTable } from "./native-table"
import { NumberInput } from "./number-input"
import { Pagination } from "./pagination"
import { PagingTable } from "./paging-table"
import { PasswordInput } from "./password-input"
import { PieChart } from "./pie-chart"
import { PinInput } from "./pin-input"
import { Popover } from "./popover"
import { Progress } from "./progress"
import { RadarChart } from "./radar-chart"
import { RadialChart } from "./radial-chart"
import { Radio } from "./radio"
import { RadioCard } from "./radio-card"
import { RangeDatePicker } from "./range-date-picker"
import { RangeSlider } from "./range-slider"
import { Rating } from "./rating"
import { Reorder } from "./reorder"
import { Resizable } from "./resizable"
import { Rotate } from "./rotate"
import { SaturationSlider } from "./saturation-slider"
import { ScaleFade } from "./scale-fade"
import { ScrollArea } from "./scroll-area"
import { SegmentedControl } from "./segmented-control"
import { Select } from "./select"
import { Separator } from "./separator"
import { Skeleton } from "./skeleton"
import { Slide } from "./slide"
import { SlideFade } from "./slide-fade"
import { Slider } from "./slider"
import { Stat } from "./stat"
import { Status } from "./status"
import { Stepper } from "./stepper"
import { Switch } from "./switch"
import { Table } from "./table"
import { Tabs } from "./tabs"
import { Tag } from "./tag"
import { Text } from "./text"
import { Textarea } from "./textarea"
import { Toggle } from "./toggle"
import { Tooltip } from "./tooltip"
import { YearPicker } from "./year-picker"

export const components = {
  Accordion,
  Airy,
  Alert,
  AlphaSlider,
  AreaChart,
  Autocomplete,
  Avatar,
  Badge,
  BarChart,
  Blockquote,
  Breadcrumb,
  Button,
  Calendar,
  Card,
  Carousel,
  Checkbox,
  CheckboxCard,
  CircleProgress,
  CloseButton,
  Code,
  Collapse,
  ColorPicker,
  ColorSelector,
  ColorSwatch,
  Container,
  ContextMenu,
  DataList,
  DatePicker,
  Dialog,
  Divider,
  DonutChart,
  Drawer,
  Dropzone,
  Editable,
  Em,
  EmptyState,
  Fade,
  Fieldset,
  FileButton,
  FileInput,
  Flip,
  For,
  FormatByte,
  FormatNumber,
  FormControl,
  Heading,
  HueSlider,
  Icon,
  Image,
  Indicator,
  InfiniteScrollArea,
  Input,
  Kbd,
  LineChart,
  Link,
  LinkBox,
  List,
  Loading,
  Mark,
  Markdown,
  Menu,
  Modal,
  MonthPicker,
  MultiAutocomplete,
  MultiDatePicker,
  MultiSelect,
  NativeSelect,
  NativeTable,
  NumberInput,
  Pagination,
  PagingTable,
  PasswordInput,
  PieChart,
  PinInput,
  Popover,
  Progress,
  RadarChart,
  RadialChart,
  Radio,
  RadioCard,
  RangeDatePicker,
  RangeSlider,
  Rating,
  Reorder,
  Resizable,
  Rotate,
  SaturationSlider,
  ScaleFade,
  ScrollArea,
  SegmentedControl,
  Select,
  Separator,
  Skeleton,
  Slide,
  SlideFade,
  Slider,
  Stat,
  Status,
  Stepper,
  Switch,
  Table,
  Tabs,
  Tag,
  Text,
  Textarea,
  Toggle,
  Tooltip,
  YearPicker,
}
